import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getPeople as getPeopleAc,
  getDamage as getDamageAc,
  getHouses as getHousesAc,
} from '../redux/effects/effectDescriptorActions';
import { Loading } from './loadbar/Loading';


class CommonDataLoaderUnwrapped extends Component {
  componentDidMount() {
    const {
      getDamage, getHouses, getPeople,
    } = this.props;
    getDamage();
    getHouses();
    getPeople();
  }

  render() {
    const { fetched, children } = this.props;

    if (!fetched) {
      return (<Loading />);
    }

    return children;
  }
}

CommonDataLoaderUnwrapped.propTypes = {
  children: PropTypes.node.isRequired,
  getPeople: PropTypes.func.isRequired,
  getDamage: PropTypes.func.isRequired,
  getHouses: PropTypes.func.isRequired,
  fetched: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  fetched: [
    state.getIn(['effectDescriptors', 'peopleFetched']),
    state.getIn(['effectDescriptors', 'damageFetched']),
    state.getIn(['effectDescriptors', 'housesFetched']),
  ].every(v => v),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  getPeople: getPeopleAc,
  getDamage: getDamageAc,
  getHouses: getHousesAc,
}, dispatch);

export const CommonDataLoader = connect(mapStateToProps, mapDispatchToProps)(CommonDataLoaderUnwrapped);
